import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { IntencionPagoService } from './services/intencion-pago.service';
import { IntencionPago, IntencionPagoResponse } from './models/intencion-pago';
import { Subscription } from 'rxjs/internal/Subscription';
import { interval } from 'rxjs/internal/observable/interval';
import { switchMap, takeWhile } from 'rxjs/operators';
import { environment } from '../environments/environment';
import QRCode from 'qrcode';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatButtonToggleModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  
  selectedIndex = 0;  
  dots = [0, 1, 2];  
  showPopup: boolean = false;
  isLoading: boolean = false; 
  result: boolean = false; 
  errorLoading: boolean = false; 
  intencionPago!: IntencionPago;
  datosPago!: IntencionPagoResponse;
  qrCodeImage: string = '';
  sdkData: any;
  callBackUrl!: string;
  errorUrl!: string;
  errorPagadaUrl: string = environment.gobiernoUrl;
  counter: number = 5;
  interval: any;
  stateOfTheIntention: string = '';

  private subscription!: Subscription;

  constructor(
    private intencionPagoService: IntencionPagoService
  ){}

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(): void {

    console.log('SDK Angular ngOnInit');
    console.log('Environment:', environment.env);

    window.addEventListener("message", (event) => {
      if (event.data.action === "sdk-data") {
        this.sdkData = event.data;
        this.generateIntention();
      }
    }, false);

    this.showLoader();
  }

  showLoader(): void {
    this.showPopup = true;
    this.isLoading = true;
  }

  detectDevice(intencionId: string): void {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('android') || userAgent.includes('iphone') || userAgent.includes('ipad')) {
      this.closeIframeAndRedirect(environment.backendUrl + '/commons-services/buepp/pasarela?id=' + intencionId);
    } else {
      this.validateIntention();
    }
  }

  generateIntention(): void {

    this.intencionPago = {
      apiKey: this.sdkData.apiKey,
      apiSecret: this.sdkData.apiSecret, 
      comercioId: this.sdkData.comercioId,
      tipoPago: this.sdkData.jsonPago.tipoPago,
      datosPago: {
            numeroBoleta: this.sdkData.jsonPago.datosPago.numeroBoleta,
            importe: this.sdkData.jsonPago.datosPago.importe,
            tramite: this.sdkData.jsonPago.datosPago.tramite,    
            usuarioLinkPagos: this.sdkData.jsonPago.datosPago.usuarioLinkPagos,
            concepto: this.sdkData.jsonPago.datosPago.concepto,
            fechaVencimiento: this.sdkData.jsonPago.datosPago.fechaVencimiento,
            idCobro: this.sdkData.jsonPago.datosPago.idCobro,
            transaccion: this.sdkData.jsonPago.datosPago.transaccion
        }
    };

    this.intencionPagoService.crearIntencion(this.intencionPago).subscribe({
      next: (response) => {
        this.datosPago = response;
        this.callBackUrl = response.callBackUrl;
        this.errorUrl = response.errorUrl;
        this.detectDevice(response.intencionId);
      },error: () => {
        this.closeIframe();
      }
    });
  }

  validateIntention(): void {

    this.isLoading = false;

    if (this.datosPago.estado === 'CREADA') {
      this.generateQr(this.datosPago.qr);
      this.queryIntention(this.datosPago.intencionId, this.intencionPago);
    } else {
      this.result = true;
      this.stateOfTheIntention = 'FINALIZADA_ERROR';
      this.errorLoading = true;
    }
  }

  generateQr(qrData: string): void {
    QRCode.toDataURL(qrData)
      .then(url => {
        this.qrCodeImage = url;
      })
  }

  queryIntention(intencionId: string, intencionPago: IntencionPago): void {
    const estadosFinales = [
      'FINALIZADA_OK',
      'FINALIZADA_ERROR',
      'VENCIDA',
      'FINALIZADA_CON_ERROR_YA_PAGADA',
      'FINALIZADA_OK_PAGO_NO_INFORMADO'
    ];

    this.subscription = interval(2000)
      .pipe(
        switchMap(() => this.intencionPagoService.consultarIntencion(intencionId, intencionPago)),
        takeWhile(response => !estadosFinales.includes(response.estado), true)
      )
      .subscribe({
        next: response => {
          const { estado, urlCallBack } = response;
          this.stateOfTheIntention = estado;

          const redirectIfFinal = () => {
            this.result = true;
            this.redirect(urlCallBack ?? this.callBackUrl);
          };

          switch (estado) {
            case 'INICIADA':
              this.selectedIndex = 1;
              break;

            case 'EN_PROCESO':
              this.selectedIndex = 2;
              break;

            case 'FINALIZADA_OK':
            case 'FINALIZADA_OK_PAGO_NO_INFORMADO':
            case 'FINALIZADA_CON_ERROR_YA_PAGADA':
            case 'FINALIZADA_ERROR':
            case 'VENCIDA':
              redirectIfFinal();
              break;
          }
        },
        error: err => {
          console.error('Error al consultar intención:', err);
          this.subscription?.unsubscribe();
        }
      });
  }
  
  formatDate(date: string): string {
    const year = date.slice(0, 2); 
    const month = date.slice(2, 4);
    const day = date.slice(4, 6); 
  
    return `${day}/${month}/${year}`;
  }

  closeIframe(): void {
    window.parent.postMessage({ action: "close-iframe" }, "*");
  }

  closeIframeAndRedirect(selectedUrl: string): void {
    window.parent.postMessage({ action: "close-iframe-and-redirect", url: selectedUrl }, "*");
  }

  startCounter(): void {
    this.interval = setInterval(() => {
      if (this.counter > 0) {
        this.counter--;
      } else {
        clearInterval(this.interval);
      }
    }, 1000);
  }

  redirect(selectedUrl: string): void {

    this.startCounter();

    setTimeout(() => {
      this.closeIframeAndRedirect(selectedUrl);
    }, 5000);
    
  }
}
